import Styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Logo from '../_UI/logo';
import LangSwitcher from '../_UI/langSwitcher';
import Navigation from '../_UI/navigation';

const Header = () => {
    const { t } = useTranslation();
    const [mobileMenu, setMobileMenu] = useState(false);

    useEffect(() => {
        const body = document.body;
        const html = document.documentElement;

        const prevBodyOverflow = body.style.overflow;
        const prevHtmlOverflow = html.style.overflow;

        if (mobileMenu) {
            body.style.overflow = 'hidden';
            html.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
            html.style.overflow = '';
        }

        return () => {
            body.style.overflow = prevBodyOverflow || '';
            html.style.overflow = prevHtmlOverflow || '';
        };
    }, [mobileMenu]);

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.logoWrap}>
                    <Logo isLink={true} />
                </div>

                <div className={Styles.dNav}>
                    <Navigation />
                </div>

                <div className={Styles.btnsWrap}>
                    <LangSwitcher />
                </div>

                <div
                    className={`${Styles.mobileBtn} ${mobileMenu ? Styles.mobileBtnActive : ''}`}
                    onClick={() => setMobileMenu((prev) => !prev)}
                >
                    <div />
                    <div />
                    <div />
                </div>
            </div>

            <div className={`${Styles.mobileMenu} ${mobileMenu ? Styles.mobileMenuOpen : ''}`}>
                <Navigation isMobile={true} mobileMenu={mobileMenu} />

                <div className={Styles.mobileBtnsWrap}>
                    <LangSwitcher />
                </div>
            </div>
        </section>
    );
};

export default Header;

